/**
 * Displays a preview version of the employer profile
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Pagination } from '@finn-no/troika-react-pagination';
import '@finn-no/troika-react-pagination/style.css';

import { createUrl } from '../../utils/createUrl';
import SearchCompaniesInput from './components/SearchCompaniesInput';
import Spinner from '../../components/gfx/Spinner';
import ServerError from '../../components/spaden/ServerError';

import AllProfilesItem from './AllProfilesItem';

import './AllProfiles.css';

class AllProfilesCollection extends React.PureComponent {
    static propTypes = {
        error: PropTypes.bool,
        loaded: PropTypes.bool,
        pageNum: PropTypes.number.isRequired,
        pageSize: PropTypes.number.isRequired,
        totalCount: PropTypes.number.isRequired,
        companies: PropTypes.array.isRequired,
        onSearchInputChange: PropTypes.func.isRequired,
    };

    render() {
        const loading = (
            <div className="panel u-text-center">
                <Spinner />
            </div>
        );

        const result = this.props.companies.map((company) => {
            const logo =
                company.logo || createUrl('img/no_image_universal_260px.png');
            const link = createUrl(`company/${company.id}`);

            return (
                <AllProfilesItem
                    companyName={company.companyName}
                    description={company.description}
                    key={company.id}
                    link={link}
                    logo={logo}
                />
            );
        });

        const pageCount = Math.ceil(
            this.props.totalCount / this.props.pageSize
        );
        const currentPage = this.props.pageNum;
        return (
            <React.Fragment>
                <nav aria-label="Her er du" className="panel breadcrumbs">
                    <a href="/job/browse.html">Jobb</a>
                    <Link to={createUrl('companies')}>Bedriftsprofiler</Link>
                </nav>
                <div className="panel">
                    <SearchCompaniesInput
                        onSearchInputChange={this.props.onSearchInputChange}
                    />
                </div>
                {this.props.error ? (
                    <ServerError />
                ) : this.props.loaded ? (
                    result
                ) : (
                    loading
                )}
                <div className="panel">
                    <Pagination
                        createHref={(page) => createUrl(`companies/${page}`)}
                        currentPage={currentPage}
                        lastPage={pageCount}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default AllProfilesCollection;
